// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkbox .Checkbox__input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.Checkbox .Checkbox__text {
    position: relative;
    padding-left: 25px;
    padding-right: 10px;
    cursor: pointer;
    display: inline-block; 
    height: 25px;
    line-height: 1.5;
    font-size: 1rem;
    user-select: none;
    font-weight: normal;
}

.Checkbox .Checkbox__text:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 18px;
    height: 18px;
    z-index: 0;
    border: 2px solid var(--palette-gray-7);
    border-radius: 1px;
    margin-top: 3px;
    transition: .2s;
}

.Checkbox.Checkbox--disabled .Checkbox__text{
    cursor: not-allowed;
}

.Checkbox.Checkbox--disabled:not(.Checkbox--checked) .Checkbox__text:before {
    border-color: var(--palete-disabled);
}

.Checkbox.Checkbox--checked .Checkbox__text:before {
    top: -4px;
    left: -5px;
    width: 12px;
    height: 22px;
    border-top: 2px solid transparent;
    border-left: 2px solid transparent;
    border-right: 1px solid;
    border-bottom: 1px solid;
    transform: rotate(40deg);
    backface-visibility: hidden;
    transform-origin: 100% 100%;
}

.Checkbox.Checked--checked.Checkbox--disabled .Checkbox__text:before {
    border-right: 2px solid var(--palette-disabled);
    border-bottom: 2px solid var(--palette-disabled);
}

.Checkbox .Checkbox__text:after {
    border-radius: 2px;
}

.Checkbox .Checkbox__text:before,
.Checkbox .Checkbox__text:after {
    content: '';
    left: 0;
    position: absolute;
    /* .1s delay is for check animation */
    transition: border .25s, background-color .25s, width .20s .1s, height .20s .1s, top .20s .1s, left .20s .1s;
    z-index: 1;
}

.Checkbox:not(.Checkbox--checked) .Checkbox__text:before {
    width: 0;
    height: 0;
    border: 3px solid transparent;
    left: 6px;
    top: 10px;
    transform: rotateZ(37deg);
    transform-origin: 100% 100%;
}

.Checkbox:not(.Checkbox--checked) .Checkbox__text:after {
    height: 17px;
    width: 17px;
    background-color: transparent;
    border: 2px solid var(--palette-gray-7);
    top: 0;
    z-index: 0;
}

.Checkbox .Checkbox__input:checked + .Checkbox__text:before {
    top: -2px;
    left: 0;
    width: 8px;
    height: 13px;
    border-top: 2px solid transparent;
    border-left: 2px solid transparent;
    border-right: 2px solid var(--palette-thribee-white);
    border-bottom: 2px solid var(--palette-thribee-white);
    transform: rotateZ(37deg);
    transform-origin: 100% 100%;
}

.Checkbox .Checkbox__input:checked + .Checkbox__text:after {
    top: 0;
    width: 17px;
    height: 17px;
    border: 2px solid var(--palette-trovit-blue);
    background-color: var(--palette-trovit-blue);
    z-index: 0;
}

.Checkbox.Checkbox--disabled:not(.Checkbox--checked) .Checkbox__text:before {
    background-color: transparent;
    border: 2px solid transparent;
}

.Checkbox.Checkbox--disabled:not(.Checkbox--checked) .Checkbox__text:after {
    border-color: var(--palette-disabled);
}

.Checkbox.Checkbox--disabled.Checkbox--checked .Checkbox__text:before {
    background-color: transparent;
}

.Checkbox.Checkbox--disabled.Checkbox--checked .Checkbox__text:after {
    background-color: var(--palette-disabled);
    border-color: var(--palette-disabled);
}
`, "",{"version":3,"sources":["webpack://./js/components/library/html/input/Checkbox/Checkbox.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,uCAAuC;IACvC,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,kCAAkC;IAClC,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,+CAA+C;IAC/C,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,qCAAqC;IACrC,4GAA4G;IAC5G,UAAU;AACd;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,SAAS;IACT,SAAS;IACT,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,uCAAuC;IACvC,MAAM;IACN,UAAU;AACd;;AAEA;IACI,SAAS;IACT,OAAO;IACP,UAAU;IACV,YAAY;IACZ,iCAAiC;IACjC,kCAAkC;IAClC,oDAAoD;IACpD,qDAAqD;IACrD,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,MAAM;IACN,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;AACzC","sourcesContent":[".Checkbox .Checkbox__input {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n}\n\n.Checkbox .Checkbox__text {\n    position: relative;\n    padding-left: 25px;\n    padding-right: 10px;\n    cursor: pointer;\n    display: inline-block; \n    height: 25px;\n    line-height: 1.5;\n    font-size: 1rem;\n    user-select: none;\n    font-weight: normal;\n}\n\n.Checkbox .Checkbox__text:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 18px;\n    height: 18px;\n    z-index: 0;\n    border: 2px solid var(--palette-gray-7);\n    border-radius: 1px;\n    margin-top: 3px;\n    transition: .2s;\n}\n\n.Checkbox.Checkbox--disabled .Checkbox__text{\n    cursor: not-allowed;\n}\n\n.Checkbox.Checkbox--disabled:not(.Checkbox--checked) .Checkbox__text:before {\n    border-color: var(--palete-disabled);\n}\n\n.Checkbox.Checkbox--checked .Checkbox__text:before {\n    top: -4px;\n    left: -5px;\n    width: 12px;\n    height: 22px;\n    border-top: 2px solid transparent;\n    border-left: 2px solid transparent;\n    border-right: 1px solid;\n    border-bottom: 1px solid;\n    transform: rotate(40deg);\n    backface-visibility: hidden;\n    transform-origin: 100% 100%;\n}\n\n.Checkbox.Checked--checked.Checkbox--disabled .Checkbox__text:before {\n    border-right: 2px solid var(--palette-disabled);\n    border-bottom: 2px solid var(--palette-disabled);\n}\n\n.Checkbox .Checkbox__text:after {\n    border-radius: 2px;\n}\n\n.Checkbox .Checkbox__text:before,\n.Checkbox .Checkbox__text:after {\n    content: '';\n    left: 0;\n    position: absolute;\n    /* .1s delay is for check animation */\n    transition: border .25s, background-color .25s, width .20s .1s, height .20s .1s, top .20s .1s, left .20s .1s;\n    z-index: 1;\n}\n\n.Checkbox:not(.Checkbox--checked) .Checkbox__text:before {\n    width: 0;\n    height: 0;\n    border: 3px solid transparent;\n    left: 6px;\n    top: 10px;\n    transform: rotateZ(37deg);\n    transform-origin: 100% 100%;\n}\n\n.Checkbox:not(.Checkbox--checked) .Checkbox__text:after {\n    height: 17px;\n    width: 17px;\n    background-color: transparent;\n    border: 2px solid var(--palette-gray-7);\n    top: 0;\n    z-index: 0;\n}\n\n.Checkbox .Checkbox__input:checked + .Checkbox__text:before {\n    top: -2px;\n    left: 0;\n    width: 8px;\n    height: 13px;\n    border-top: 2px solid transparent;\n    border-left: 2px solid transparent;\n    border-right: 2px solid var(--palette-thribee-white);\n    border-bottom: 2px solid var(--palette-thribee-white);\n    transform: rotateZ(37deg);\n    transform-origin: 100% 100%;\n}\n\n.Checkbox .Checkbox__input:checked + .Checkbox__text:after {\n    top: 0;\n    width: 17px;\n    height: 17px;\n    border: 2px solid var(--palette-trovit-blue);\n    background-color: var(--palette-trovit-blue);\n    z-index: 0;\n}\n\n.Checkbox.Checkbox--disabled:not(.Checkbox--checked) .Checkbox__text:before {\n    background-color: transparent;\n    border: 2px solid transparent;\n}\n\n.Checkbox.Checkbox--disabled:not(.Checkbox--checked) .Checkbox__text:after {\n    border-color: var(--palette-disabled);\n}\n\n.Checkbox.Checkbox--disabled.Checkbox--checked .Checkbox__text:before {\n    background-color: transparent;\n}\n\n.Checkbox.Checkbox--disabled.Checkbox--checked .Checkbox__text:after {\n    background-color: var(--palette-disabled);\n    border-color: var(--palette-disabled);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
